module.exports = __webpack_public_path__ + "assets/0119ccc532ee41d69fe952c20409b77d.png";